/* eslint-disable no-case-declarations */
import {
  SET_WHATS_NEW, WHATS_NEW_REQUEST_FAILED, SENDING_WHATS_NEW_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  wData: '',
  isWSending: false,
  wError: false,
  isWSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function getWhatsNew(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_WHATS_NEW:
      const data = {};
      data.wData = action.wData;
      data.isWSending = action.isWSending;
      data.isWSuccess = action.isWSuccess;
      data.wError = action.wError;
      return { ...state, ...data };

    case SENDING_WHATS_NEW_REQUEST:
      const sendingRequest = {};
      sendingRequest.wData = action.wData;
      sendingRequest.isWSending = action.isWSending;
      sendingRequest.isWSuccess = action.isWSuccess;
      sendingRequest.wError = action.wError;
      return { ...state, ...sendingRequest };

    case WHATS_NEW_REQUEST_FAILED:
      const errors = {};
      errors.wData = action.wData;
      errors.isWSending = action.isWSending;
      errors.isWSuccess = action.isWSuccess;
      errors.wError = action.wError;
      errors.ugMsg = action.ugMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
